export function Loading({ label = "Stitching things together…" }: { label?: string }) {
  return <div className="state-panel loading-state" role="status"><span className="loading-dot" />{label}</div>;
}

export function ErrorPanel({ message = "Something came loose. Please try again." }: { message?: string }) {
  return <div className="state-panel error-state" role="alert">{message}</div>;
}

